module.exports = __webpack_public_path__ + "img/ts18.c27b7566.png";